const navConfig = [];
 
export default navConfig;
